var _path, _path2, _path3, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46152 13.9868V2.06579C3.46152 1.47368 2.98904 1 2.39845 1C1.80786 1 1.33539 1.47368 1.33539 2.06579V13.9868C1.33539 15.0921 2.24096 16 3.3434 16C4.44583 16 5.35141 15.0921 5.35141 13.9868V3.17105C5.35141 3.17105 5.35141 2.73684 5.86325 2.73684H19.5256C19.5256 2.73684 19.9981 2.77632 19.9981 3.28947V13.8684C19.9981 13.8684 20.1556 16 17.6357 16H3.3434",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39847 1H17.2026C17.2026 1 18.5807 1 18.5807 2.26316V2.77632",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2013 10.2031H8.42153C8.1853 10.2031 7.98843 10.0057 7.98843 9.76885V5.97938C7.98843 5.74253 8.1853 5.54517 8.42153 5.54517H12.2013C12.4376 5.54517 12.6344 5.74253 12.6344 5.97938V9.76885C12.6344 10.0057 12.4376 10.2031 12.2013 10.2031Z",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.48843,
    y1: 12.6487,
    x2: 16.9928,
    y2: 12.6487,
    stroke: "#2C2E3E",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.e1ec1ebb.svg";
export { ForwardRef as ReactComponent };